import { LifeCycleLabel, TeamActionStateLabel } from "../../../types/LC.Types";
import dayjs from "dayjs";
import type { MyTeamLifeCycle } from "../../../types/LC.Types";
import type { ColumnConfig } from "../DetailsTable";

const formatDate = (date?: string | null) =>
  date ? dayjs(date).format("YYYY-MM-DD") : "n/a";

export const detailsTableColumns: ColumnConfig<MyTeamLifeCycle>[] = [
  {
    header: "Team Name",
    accessor: "myTeamName",
    sortable: true,
  },
  {
    header: "Created",
    accessor: "myTeamCreatedDateTime",
    render: (item) => formatDate(item.myTeamCreatedDateTime),
    sortable: true,
  },
  {
    header: "Last Activity",
    accessor: "lastTeamActivity",
    render: (item) => formatDate(item.lastTeamActivity),
    sortable: true,
  },
  {
    header: "Expected EOL",
    accessor: "expectedEndOfLife",
    render: (item) => formatDate(item.expectedEndOfLife),
    sortable: true,
},
  {
    header: "Lifecycle State",
    accessor: "myTeamLifeCycleState",
    render: (item) => LifeCycleLabel[item.myTeamLifeCycleState],
    sortable: true,
  },
  {
    header: "Notification State",
    accessor: "actionState",
    render: (item) =>
      item.actionState ? TeamActionStateLabel[item.actionState] : "n/a",
    sortable: true,
  },
  {
    header: "Check-up",
    accessor: "lastCheckUpDate",
    render: (item) => formatDate(item.lastCheckUpDate),
    sortable: true,
  },
];
